// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2101":"9e464379b3105741","2176":"b8fb769adc79c1ff","9794":"f7eddc68d60351bc"}[chunkId] + ".js";
};